
"use strict";

var PAGESIZE = 20;

require("./CompanyFeedActivity.js");
require("./CompanyFeedActivityTranslator.js");

function FeedActivity(
  CompanyFeedActivity,
  CompanyFeedActivityTranslator,
  $stateParams,
  $state,
  $modal,
  $translate) {
  return {
    restrict:    "A",
    templateUrl: "partials/company/comments/activities.html",
    scope: {
      source:       "=feedActivity",
      user:         "=user",
      types:        "=?types",
      blogEnable:   "=?blogEnable",
      blogEditable: "=?blogEditable",
      guestView:    "=?guestView"
    },
    link: function($scope) {
      $scope.loading    = false;
      $scope.page       = 0;
      $scope.activity   = [];
      $scope.PAGESIZE   = PAGESIZE;
      $scope.type       = '';
      $scope.filterText = '';
      $scope.companyId = $stateParams.companyId;

      if ($stateParams.query) {
        $scope.filterText = $stateParams.query;
      }

      if ($stateParams.type) {
        $scope.type = $stateParams.type;
      }
      if($state.current.name === 'root.company.comments.list'){
        $scope.type = 'COMMENT';
      }
      if($state.current.name === 'root.company.comments.messages'){
        $scope.type = 'MESSAGE';
      }

      var modal;
      $scope.showModalMessage = function(message) {
        message.title = message.object.name;
        message.content = message.text;
        modal = $modal({
          scope: $scope,
          controller: 'CompanyBlogNewCtrl',
          templateUrl: 'partials/company/blogs/modal-new.html',
          show: true,
          prefixEvent: 'modalMessageDirective',
          resolve: {
            message: function() {
              return message;
            }
          }
        });
      };

      $scope.$on('modalMessageDirective', function(){
          modal.destroy();
      });

      $scope.loadData = function() {
        $scope.loading = true;
        $scope.page    = $scope.page > 0 ? $scope.page : 0;

        /* TODO: That toUpperCase() should be removed
         * and all constants should be uppercase instead.
         */
        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, $scope.type ? [$scope.type.toUpperCase()] : $scope.types, $scope.filterText).then(function(activity) {
          $scope.hasNextPage = activity.length > PAGESIZE;
          $scope.loading     = false;
          $scope.activity    = activity.map(CompanyFeedActivityTranslator);
          jQuery("html, body").animate({ scrollTop: 0 }, "slow");
        });
      };

      $scope.search = function(text) {
        if (!$scope.guestView)  {
          if($state.current.name === 'root.company.comments.list'){
            $state.go('root.company.comments.list', {query: text});
          }else{
            if($state.current.name === 'root.company.comments.messages'){
              $state.go('root.company.comments.messages', {query: text});
            }
          }
        } else {
          $state.go('root.company-guest.comments', {query: text});
        }
      };

      if( ! $scope.types) {
        $scope.types = [];
      }

      $scope.filterType = [
        {
          label: $translate.instant('all'),
          value: ''
        },
        {
          label: $translate.instant('comment'),
          value: 'COMMENT'
        },
        {
          label: $translate.instant('message'),
          value: 'MESSAGE'
        }
      ];

      $scope.loadData();

      $scope.$on('notification', function(e, data) {
        if (data.type === 'COMMENT' && data.message.parentID === 'undefined') {
          var c = {
            text: data.message.text,
            createdAt: (new Date()).toISOString(),
            type: "comment",
            user:      data.sourceUser,
            object: data.publication
          };
          $scope.$apply(function(){
            $scope.activity.unshift(c);
            $scope.source.prependDataTo("COMMENT", c);
            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
          });
        }
      });
    }
  };
}

angular.module("dokiv")
  .directive("feedActivity", [
    "CompanyFeedActivity",
    "CompanyFeedActivityTranslator",
    "$stateParams",
    "$state",
    "$modal",
    "$translate", FeedActivity]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyFeedActivityDirective.js
// module id = 58
// module chunks = 0